import { render } from "./changePassword.vue?vue&type=template&id=763e3dd4&scoped=true"
import script from "./changePassword.vue?vue&type=script&lang=js"
export * from "./changePassword.vue?vue&type=script&lang=js"

import "./changePassword.vue?vue&type=style&index=0&id=763e3dd4&lang=css"
import "./changePassword.vue?vue&type=style&index=1&id=763e3dd4&scoped=true&lang=css"

import exportComponent from "D:\\AAA_WORK\\os_FMS_sys_projectop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763e3dd4"]])

export default __exports__